


































































































import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import { storeBed } from "@/store/modules/bed";
import { appModule } from "@/store/modules/app";
import ModalKonfirmasi from "@/components/modal/ModalKonfirmasi.vue";
import ModalRekapBed from "@/components/modal/ModalRekapBed.vue";
import ModalAlert from "@/components/modal/ModalAlert.vue";
import moment from "moment";

@Component({
  components: {
    ModalKonfirmasi,
    ModalAlert,
    ModalRekapBed,
  },
})
export default class Informasi extends Vue {
  // dtBed = {};
  // itemRow = {};
  modalOpenKonfirmasi = false;
  modalKonfirmasiBed = false;
  modalRekapBed = false;
  msgConfirm = "";
  timer: number;
  search = "";
  // listBed = [];

  get headersPasien() {
    const head = [
      {
        text: "NO",
        value: "nomor",
        width: "7vh",
        align: "center",
      },
      {
        text: "NAMA",
        value: "nama",
        width: "30vh",
        align: "left",
        filterable: true,
      },
      {
        text: "NO RM",
        value: "rm",
        width: "15vh",
        align: "center",
        filterable: true,
      },
      {
        text: "ALAMAT",
        value: "alamat",
        align: "left",
        filterable: true,
      },
      {
        text: "UMUR",
        value: "umur",
        width: "15vh",
        align: "left",
        filterable: false,
      },
      {
        text: "AGAMA",
        value: "agama",
        width: "20vh",
        align: "left",
        filterable: true,
      },
      {
        text: "BANGSAL",
        value: "bed.nama",
        align: "left",
        filterable: true,
      },
      {
        text: "NO KAMAR",
        value: "bed.kamar",
        width: "15vh",
        align: "center",
        filterable: false,
      },
      {
        text: "KELAS",
        value: "kelas.nama",
        align: "center",
        width: "20vh",
        filterable: false,
      },
      {
        text: "TGL MASUK",
        value: "tgl",
        align: "center",
        width: "20vh",
        filterable: false,
      },
    ];
    return head;
  }

  // created() {
  mounted() {
    this.getPasienAll();
    this.timer = setInterval(this.getPasienAll, 600000);
  }

  get listPasienAll() {
    return storeBed.pasienAll;
  }

  get loadingPasien() {
    return storeBed.loadingPasien;
  }

  get showAlert() {
    return appModule.alert;
  }

  get errItem() {
    return {
      errorMsg: appModule.alertMessage,
      errorIcon: "mdi-alert-circle-outline",
    };
  }

  get bottomSnackbar() {
    return appModule.snackbar;
  }

  get bottomSnackbarText() {
    return appModule.notice;
  }

  get alertSnackbar() {
    return appModule.snackbaralert;
  }
  set alertSnackbar(val) {
    appModule.setSnackbaralert(val);
  }

  get alertSnackbarText() {
    return appModule.noticealert;
  }

  getPasienAll() {
    this.search = "";
    storeBed.actPasienAll();
  }

  rekapBed() {
    storeBed.actRekapBed();
    this.modalRekapBed = true;
  }
  getFormatDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD-MM-YYYY") : "";
  }
}
